/**
 * @file CustomTabPanel.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import { Box } from "@mui/material";
import React from "react";
import "./Tab.css";

/**
 * An interface definition for TabPanelProps
 */
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

/**
 * A function component for creating Custom Tab Panel
 * @param props The TabPanelProps
 * @returns 
 */
export function CustomTabPanel(props: TabPanelProps) {

    const { children, value, index, ...other } = props;
  
    return (
      <div role="tabpanel"  hidden={value !== index}
        id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`}
        {...other}> {value === index && (
          <Box sx={{ py: 3 }} className="TabContainer">
            {children}
          </Box>
        )}
      </div>
    );
  }
  
 /**
  * A function for a11yProps
  * @param index A number
  * @returns 
  */
  export function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }